import { ref } from 'vue';

import { client } from '@/shared/api/apiClient';
import { getMovementTypes } from '@/shared/api/generated/api';

// Карта: код типа передвижения (movement_type экскурсии) -> русская фраза
const movementTypeMap = ref<Record<string, string>>({});
let loadPromise: Promise<void> | null = null;

const loadMovementTypes = (): Promise<void> => {
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    try {
      const { data } = await getMovementTypes({ client, throwOnError: true });

      const map: Record<string, string> = {};

      data.movement_type.forEach((item) => {
        if (item.str) {
          map[item.str] = item.label_phrase || item.label || item.str;
        }
      });

      movementTypeMap.value = map;
    } catch {
      // Позволяем повторную попытку загрузки при следующем вызове
      loadPromise = null;
    }
  })();

  return loadPromise;
};

export const useMovementTypes = () => {
  const localizeMovementType = (movementType: string | null | undefined): string => {
    if (!movementType) return movementType ?? '';

    return movementTypeMap.value[movementType] ?? movementType;
  };

  const localizeExperienceMovement = <T extends { movement_type: string }>(exp: T): T => ({
    ...exp,
    movement_type: localizeMovementType(exp.movement_type),
  });

  return { movementTypeMap, loadMovementTypes, localizeMovementType, localizeExperienceMovement };
};
